;(function ($) {
  "use strict"

  $(document).ready(function () {
    const $body = $("body")
    const $modal = $(".modal")
    const $backdrop = $(".backdrop")
    const $inquiry = $(".inquiry-sidebar")

    function openInquiry() {
      $inquiry.addClass("is-visible")
      $body.addClass("no-scroll")
    }

    function closeInquiry() {
      $inquiry.removeClass("is-visible")
      $body.removeClass("no-scroll")
    }

    function toggleModal(element) {
      const isVisible = $modal.hasClass("is-visible")
      $modal.toggleClass("is-visible", !isVisible)
      $backdrop.fadeToggle(200)
      $body.toggleClass("no-scroll", !isVisible)

      if (!isVisible) {
        $modal.createTabTrap()
      } else {
        element.focus()
      }
    }

    $(document).on("click", function (event) {
      const $target = $(event.target)

      if ($inquiry.length && $target.closest(".modal-open").length) {
        event.preventDefault()
        openInquiry()
        return
      }

      if (
        $target.closest(".modal-open").length ||
        $target.closest(".modal-close").length ||
        $target.closest(".backdrop").length
      ) {
        event.preventDefault()
        toggleModal(event.target)
      }

      // Close inquiry sidebar
      if ($target.closest(".close-inquiry-sidebar").length) {
        event.preventDefault()
        closeInquiry()
      }
    })

    $(document).on("keydown", function (event) {
      if (event.key === "Escape") {
        if ($inquiry.length && $inquiry.hasClass("is-visible")) {
          closeInquiry()
          return
        }

        if ($modal.hasClass("is-visible")) {
          toggleModal(event.target)
        }
      }
    })


    var $input = $('input[name="number-654"]')

    $('#increase-number').on('click', function () {
      var currentVal = parseInt($input.val(), 10) || 0
      $input.val(currentVal + 1).trigger('change')
    })

    $('#decrease-val').on('click', function () {
      var currentVal = parseInt($input.val(), 10) || 0

      if (currentVal > 0) {
        $input.val(currentVal - 1).trigger('change')
      }
    })
  })
})(jQuery)
